export default "/images/vendor/@coreui/icons/svg/flag/cif-at.svg?4193cc401d4986543bbc878ad6df389b";